/**
 * @generated SignedSource<<26337d4ad67a6799138ccaec4be716b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowInner_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow" | "useRowColorOld_rules">;
  readonly " $fragmentType": "RowInner_project";
};
export type RowInner_project$key = {
  readonly " $data"?: RowInner_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowInner_project",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useRowColorOld_rules"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "97ba10170154eb6d8e33408a5325b229";

export default node;
